import * as React from "react"
import styles from "./IsolatedViewPopup/styles.module.scss"
import Popup from "../../../Componnets/Popup/Popup";
import Button from "../../../Componnets/mainButton/Button";
import {useContext, useEffect, useRef} from "react";
import {getCurrentFilters} from "../../../../util/currentFiltersHelper";
import appContext from "../../../../context/appContext";
import {useHistory} from "react-router-dom";

const IsolatedViewPopup = (props) => {
  const myRef = useRef();

  const handleClickOutside = e => {
    if (!myRef.current?.contains(e.target) && props.show) {
      props.onTriggerShowPopup();
    }
  };

  useEffect(() => {
    document.addEventListener('mouseup', handleClickOutside);
    return () => document.removeEventListener('mouseup', handleClickOutside);
  });

  const history = useHistory()
  const context = useContext(appContext)
  const handleGoToDataAnalysis = () => {
    const arr = [...props.sequenceList]
    arr?.shift()
    const filters = {
      currentFilters: getCurrentFilters(context, history.location.pathname),
      newFlowSelection: props.sequenceList?.length ? {
        fromNode: props.sequenceList[0],
        toListOfNodes: arr
      } : undefined
    }

    context.handleOverrideDataAnalysisFilters(filters)
    history.push('/data-analysis');
    context.handleAddTab(4, 'Data Analysis', 'data-analysis');
  }

  return (
    <div ref={myRef} className={styles.IsolatedViewPopup}>
      <Popup show={props.show} title={"Make Isolated View"} onClose={props.onTriggerShowPopup}>
        <p>
          You can create a totally isolated view with the case in this vilation. To do so, just select a feature and Rahkav will attach the view to the current tab.
        </p>
        <div className={styles.mainContent}>
          {/*<div>*/}
          {/*  <Button size={"medium"}*/}
          {/*          textSize={"fontLight"}*/}
          {/*          hoverOutlined*/}
          {/*          block*/}
          {/*  >Process Map</Button>*/}
          {/*</div>*/}
          <div className={'mt-2'}>
            <Button size={"medium"}
                    textSize={"fontLight"}
                    hoverOutlined
                    block
                    onClick={handleGoToDataAnalysis}
            >Data Analysis</Button>
          </div>
          {/*<div className={'mt-2'}>*/}
          {/*  <Button size={"medium"}*/}
          {/*          textSize={"fontLight"}*/}
          {/*          hoverOutlined*/}
          {/*          block*/}
          {/*  >Process Compare</Button>*/}
          {/*</div>*/}
        </div>
      </Popup>
    </div>
  )
}

export default IsolatedViewPopup
